{
  "book": {
    "brand": "Smart Word Labs",
    "breadcrumb": "Book a Free Assessment",
    "errors": {
      "generic": "Could not book your assessment"
    },
    "success": {
      "title": "Assessment Booked!",
      "body": "Check your email for confirmation and login details. We've sent a secure sign-in link to",
      "bodyEnd": "so you can access your parent portal without a password.",
      "backHome": "Back to home"
    },
    "form": {
      "title": "Book your free assessment",
      "subtitle": "Takes under a minute. No account or payment details needed — we'll set your parent portal up for you.",
      "parentName": "Parent name",
      "parentEmail": "Parent email",
      "childName": "Child's name",
      "childAge": "Child's age",
      "date": "Preferred date",
      "time": "Preferred time",
      "booking": "Booking…",
      "submit": "Book free assessment",
      "alreadyEnrolled": "Already enrolled?",
      "parentSignIn": "Parent Sign In",
      "localTimeNote": "Times shown in your time zone"
    }
  },
  "checkout": {
    "title": "Secure checkout",
    "summary": "{{name}} — ${{monthly}} per month, {{lessons}}. Cancel any time.",
    "couldNotStart": "Checkout could not be started",
    "choosePlan": {
      "before": "Choose a plan on the",
      "link": "pricing page",
      "after": "to continue."
    },
    "summaryOneTime": "{{name}} — ${{monthly}} USD one-time, {{lessons}}."
  },
  "contact": {
    "breadcrumb": "Contact Us",
    "title": "Contact Us",
    "subtitle": "Use the form below and we'll get back to you personally within one working day.",
    "eyebrow": "Talk to us",
    "heading": "Questions about your child's English?",
    "description": "Send a message and Ms. Salma will get back to you personally. Share your WhatsApp number if you'd prefer a quick voice note or call instead of email.",
    "bullets": {
      "email": "We reply by email within one working day (Mon–Sat).",
      "whatsapp": "Prefer WhatsApp? Add your number and we'll message you there."
    },
    "form": {
      "name": "Parent name",
      "email": "Email",
      "whatsapp": "WhatsApp number (optional)",
      "dialCodeAria": "Country dialling code",
      "whatsappPlaceholder": "300 1234567",
      "childAge": "Child's age (optional)",
      "childAgePlaceholder": "e.g. 7",
      "subject": "Subject (optional)",
      "subjectPlaceholder": "Class timings, pricing, assessment…",
      "message": "Message",
      "sending": "Sending…",
      "pleaseWait": "Please wait {{seconds}}s…",
      "send": "Send message",
      "sentTitle": "Message received",
      "sentBody": "Thank you — we have your details and will be in touch shortly.",
      "sendAnother": "Send another message",
      "privacyBefore": "We use your details only to reply to this enquiry. See our",
      "privacyLink": "privacy notice",
      "success": "Message sent — we'll reply within one working day.",
      "validation": {
        "nameRequired": "Please enter your name",
        "emailInvalid": "Please enter a valid email address",
        "whatsappTooLong": "WhatsApp number is too long",
        "whatsappFormat": "Use digits, spaces, + or - only",
        "messageTooShort": "Please tell us a little more"
      },
      "errors": {
        "tooFast": "That was quick! Please take a moment and try again.",
        "checkForm": "Please check the form",
        "captcha": "We couldn't verify this submission. Please try again.",
        "sendFailed": "We couldn't send your message. Please try again."
      }
    }
  },
  "howItWorks": {
    "breadcrumb": "How It Works",
    "hero": {
      "title": "How our online English classes work",
      "subtitle": "Small groups. Big speaking confidence. Every child is assessed, placed and tracked against CEFR benchmarks, then taught live in a cohort of no more than five."
    },
    "pillars": {
      "title": "Our three teaching principles"
    },
    "steps": {
      "title": "From enquiry to first lesson"
    },
    "cta": {
      "book": "Book Free Assessment",
      "browsePrograms": "Browse programmes by age",
      "seePricing": "See pricing"
    }
  },
  "pricing": {
    "breadcrumb": "Pricing",
    "compareLink": "Not sure which level? Compare the programmes"
  },
  "paymentBanner": {
    "notConfigured": "Production checkout is not configured yet. Complete payment go-live to accept real payments.",
    "testMode": "All payments made in the preview are in test mode.",
    "testModeLink": "View payment test mode documentation",
    "notReady": "Live payments are not fully ready yet: {{failures}}. Checking again automatically."
  },
  "faq": {
    "title": "Questions parents ask us",
    "subtitle": "Free assessments, tech, scheduling, payments, placement and refunds — answered in full.",
    "items": [
      {
        "q": "Is the free assessment really free, and what happens in it?",
        "a": "Yes — the first session is a completely free 20–30 minute assessment with Ms. Salma, with no card details required. Your child chats, reads and plays a short speaking task while she benchmarks them against CEFR levels. Within one working day you receive a written learning plan and a recommended cohort. There is no obligation to enrol afterwards."
      },
      {
        "q": "What equipment and internet speed do we need?",
        "a": "A laptop, desktop or tablet with a webcam and a stable connection of roughly 5 Mbps is enough — lessons run in the browser on Zoom, so there is nothing to install beyond that. Headphones with a microphone make a big difference for younger children, and a quiet, well-lit spot helps them stay focused. Phones work in a pinch, but the screen is too small for shared reading tasks."
      },
      {
        "q": "How do we reschedule or cancel a lesson?",
        "a": "Reschedule from the parent portal at least 12 hours before the lesson. Each plan includes reschedule credits (2 on Starter, 4 on Intensive, unlimited on Private). Beyond that we will try to place your child in another cohort at the same level that week at no extra cost, and if nothing suitable is available your teacher sends a recorded catch-up task and covers the gap in the next lesson."
      },
      {
        "q": "What payment methods do you accept, and is it secure?",
        "a": "Plans are billed monthly in USD through Stripe, which accepts Visa, Mastercard, American Express, Apple Pay, Google Pay and most local card networks. We never see or store your card number — everything is handled on Stripe's PCI-compliant checkout. You can update your card or cancel any time from the parent portal, and cancelling simply stops the next renewal."
      },
      {
        "q": "How is my child placed in the right age group and level?",
        "a": "Placement is by CEFR level first and age band second, so a confident six-year-old is never held back and a quieter nine-year-old is never overwhelmed. The free assessment gives us the level; the age bands (4–6 Early Phonics Explorers, 7–9 Literacy Builders, 10–12 Confident Communicators) then decide the pace, materials and lesson length. If a child outgrows a cohort mid-term we move them up at no charge."
      },
      {
        "q": "What is your refund policy?",
        "a": "If you are not happy after your child's first paid month, email us within 14 days of that first charge and we will refund it in full. After that, cancelling stops the next renewal and you keep every lesson already paid for until the end of the billing month — we do not charge cancellation fees. Full details are in our refund policy."
      },
      {
        "q": "How will I know my child is progressing?",
        "a": "Every child is assessed against CEFR levels at the start. You receive a written progress report each month, and if progress is slower than planned, Ms. Salma adjusts the learning plan and discusses it with you."
      }
    ]
  },
  "faculty": {
    "title": "Meet your teacher",
    "subtitle": "Every lesson is taught by Ms. Salma, a CELTA-certified specialist in young-learner English, working from our CEFR-aligned curriculum.",
    "teacher": {
      "name": "Ms. Salma",
      "credential": "CELTA certified (Cambridge English) · BA English & Applied Psychology",
      "experience": "10+ years teaching English, primary through adult, across Canada and the Middle East",
      "detail": "British-curriculum early literacy and phonics, CEFR-aligned lessons, IELTS and interview coaching.",
      "quote": "Phonics sticks when it sounds like play, not drill.",
      "photoAlt": "Ms. Salma, CELTA-certified English teacher at Smart Word Labs"
    }
  },
  "testimonials": {
    "title": "What parents say about our online English classes",
    "ratingSummary": "4.9/5 from 1,200+ verified parent reviews",
    "starsAria": "{{rating}} out of 5 stars",
    "prevAria": "Previous reviews",
    "nextAria": "Next reviews",
    "pageAria": "Show review page {{page}}",
    "reviews": [
      {
        "quote": "Aariz went from single-word answers to telling us full stories about his lesson. The cohort of four means he actually has to speak — that changed everything.",
        "name": "Sana M.",
        "childAge": "Parent of a 6-year-old",
        "location": "Dubai, UAE",
        "rating": 5
      },
      {
        "quote": "The monthly CEFR report is the first thing I've had that actually shows progress rather than just 'she's doing well'. Worth every penny.",
        "name": "Rachel T.",
        "childAge": "Parent of a 9-year-old",
        "location": "London, UK",
        "rating": 5
      },
      {
        "quote": "Both of my children are on the same account and I can see their lessons side by side. Rescheduling takes ten seconds.",
        "name": "Ibrahim K.",
        "childAge": "Parent of two, ages 7 and 11",
        "location": "Karachi, Pakistan",
        "rating": 5
      },
      {
        "quote": "Literacy Builders turned reading from a fight into something she asks for. Her writing at school jumped a whole level in one term.",
        "name": "Priya N.",
        "childAge": "Parent of an 8-year-old",
        "location": "Singapore",
        "rating": 5
      },
      {
        "quote": "Confident Communicators is exactly what our son needed before secondary school — he now presents an argument at the dinner table without blinking.",
        "name": "Marco B.",
        "childAge": "Parent of an 11-year-old",
        "location": "Milan, Italy",
        "rating": 5
      },
      {
        "quote": "The Early Phonics lessons are only 30 minutes, which is perfect for a five-year-old's attention span. He sounds out words everywhere we go now.",
        "name": "Hannah L.",
        "childAge": "Parent of a 5-year-old",
        "location": "Manchester, UK",
        "rating": 5
      },
      {
        "quote": "We used the interview preparation programme before entrance assessments. Our daughter walked in genuinely relaxed and got her first-choice place.",
        "name": "Elena V.",
        "childAge": "Parent of a 10-year-old",
        "location": "Madrid, Spain",
        "rating": 5
      },
      {
        "quote": "Ms. Salma noticed within two lessons that my son was guessing rather than decoding. Nobody at school had spotted it in a year.",
        "name": "Yusuf A.",
        "childAge": "Parent of a 7-year-old",
        "location": "Doha, Qatar",
        "rating": 5
      },
      {
        "quote": "The free assessment alone was more useful than the paid trials we did elsewhere. We enrolled the same week and haven't looked back.",
        "name": "Claire D.",
        "childAge": "Parent of a 9-year-old",
        "location": "Toronto, Canada",
        "rating": 4
      }
    ]
  },
  "placementQuiz": {
    "eyebrow": "30-second placement",
    "title": "Find the right cohort in 30 seconds",
    "subtitle": "Three quick questions and we'll point you to the programme that fits your child.",
    "stepOf": "Step {{current}} of {{total}}",
    "back": "← Back",
    "recommended": "Recommended programme",
    "bookCta": "Book your free assessment",
    "seeFullProgramme": "See the full programme",
    "startAgain": "Start again",
    "reasons": {
      "new": "We'll start with sounds and short spoken answers so your child builds confidence before pace.",
      "confident": "Your child is ready for longer speaking turns, so lessons push structure, vocabulary and argument.",
      "default": "Lessons balance guided practice with plenty of independent speaking time."
    },
    "steps": [
      {
        "key": "age",
        "title": "How old is your child?",
        "options": [
          {
            "value": "4-6",
            "label": "4–6 years"
          },
          {
            "value": "7-9",
            "label": "7–9 years"
          },
          {
            "value": "10-12",
            "label": "10–12 years"
          }
        ]
      },
      {
        "key": "goal",
        "title": "What matters most right now?",
        "options": [
          {
            "value": "phonics",
            "label": "Reading & phonics"
          },
          {
            "value": "writing",
            "label": "Writing & school work"
          },
          {
            "value": "speaking",
            "label": "Speaking confidence"
          },
          {
            "value": "exams",
            "label": "Exams & interviews"
          }
        ]
      },
      {
        "key": "comfort",
        "title": "How comfortable is your child speaking English?",
        "options": [
          {
            "value": "new",
            "label": "Just starting out"
          },
          {
            "value": "some",
            "label": "A few sentences"
          },
          {
            "value": "confident",
            "label": "Chats fairly freely"
          }
        ]
      }
    ]
  },
  "cohortTimeConverter": {
    "intro": "Ms. Salma teaches from Toronto. Lesson times in your time zone:",
    "timezoneLabel": "Your time zone",
    "timezonePlaceholder": "Select your time zone",
    "footnote": "Times shown in your local time. Your exact slot is confirmed during the free assessment."
  }
}
